export default __webpack_public_path__ + "static/media/chemotharapyDays.626eff35.png";